import React, { useEffect } from "react";
import CalendarSlot from "./CalendarSlot/CalendarSlot";
import { useDispatch, useSelector } from "react-redux";
import getCalendarDays from "../../../../Utils/getCalendarDays";

import "./CalendarContent.css";
import { getEvents } from "../../../../REDUX/actions/events";

function CalendarContent({ selectedOption }) {
  const date = useSelector((state) => state.calendarReducer.date);
  let dates = getCalendarDays(date);
  let indexOfOne = dates.findIndex(({ day }) => day === 1);
  const { events } = useSelector((state) => state.eventsReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    const controller = new AbortController();
    dispatch(getEvents(controller.signal));
    return () => controller.abort();
  }, [dispatch]);

  return (
    <div className="calendarContent d-flex flex-wrap">
      {dates.map(({ date, day }, index) => {
        return (
          <CalendarSlot
            key={index}
            date={date}
            day={day}
            index={index}
            indexOfOne={indexOfOne}
            events={events?.data}
            selectedOption={selectedOption}
          />
        );
      })}
    </div>
  );
}

export default CalendarContent;
